<template>
  <section class="pt-24 pb-40" v-if="dataTrip">
    <div class="flex mb-db">
      <div class="mr-80 mb-mb-24 mb-mr-0">
        <h2 class="heading-6-bd mb-8">What’s included?</h2>
        <ul >
          <li v-for="(item, i) in dataTrip.inclusions" :key="i" class="flex items-center mb-4">
            <DJIcon class="mr-8" color="#197660">
              <IconCheck />
            </DJIcon>
            <span class="text-md-rg">{{ item }}</span>
          </li>
        </ul>
      </div>
      <div>
        <h2 class="heading-6-bd mb-8">What’s not included?</h2>
        <ul>
          <li v-for="(item, i) in dataTrip.exclusions" :key="i" class="flex items-center mb-4">
            <DJIcon class="mr-8">
              <IconX />
            </DJIcon>
            <span class="text-md-rg">{{ item }}</span>
           </li>
        </ul>
      </div>
    </div>
    <div class="br-12 bg-gray-branding py-30 px-30 mt-60" v-if="dataTrip.notes">
      <h4 class="mb-20 fs-18 lh-18">Notes</h4>
      <div class="fs-14 lh-18" v-html="dataTrip.notes"></div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, inject } from 'vue'
import DJIcon from '~/components/ui/icon/Icon.vue'
import { IconCheck, IconX } from '~/components/ui/icon/icons'
const dataTrip = inject('dataTrip', ref<any>({}))
</script>
